var items = {
  "block.minecraft.air": "aire",
  "block.minecraft.stone": "roca",
  "block.minecraft.granite": "granito",
  "block.minecraft.polished_granite": "granito pulío",
  "block.minecraft.diorite": "diorita",
  "block.minecraft.polished_diorite": "diorita pulía",
  "block.minecraft.andesite": "andeçita",
  "block.minecraft.polished_andesite": "andeçita pulía",
  "block.minecraft.grass_block": "bloque de yerba",
  "block.minecraft.dirt": "tierra",
  "block.minecraft.coarse_dirt": "tierra êttérî",
  "block.minecraft.podzol": "podçol",
  "block.minecraft.crimson_nylium": "nilio carmeçí",
  "block.minecraft.warped_nylium": "niçelio êttrambótico",
  "block.minecraft.cobblestone": "adoquín",
  "block.minecraft.oak_planks": "tablonê de quehigo",
  "block.minecraft.spruce_planks": "tablonê de pinçapo",
  "block.minecraft.birch_planks": "tablonê de xopo",
  "block.minecraft.jungle_planks": "tablonê de hungla",
  "block.minecraft.acacia_planks": "tablonê de mimoça",
  "block.minecraft.dark_oak_planks": "tablonê de xaparro",
  "block.minecraft.crimson_planks": "tablonê carmeçíê",
  "block.minecraft.warped_planks": "tablonê êttrambóticô",
  "block.minecraft.oak_sapling": "brote de quehigo",
  "block.minecraft.spruce_sapling": "brote de pinçapo",
  "block.minecraft.birch_sapling": "brote de xopo",
  "block.minecraft.jungle_sapling": "brote de hungla",
  "block.minecraft.acacia_sapling": "brote de mimoça",
  "block.minecraft.dark_oak_sapling": "brote de xaparro",
  "block.minecraft.bedrock": "roca baçe",
  "block.minecraft.sand": "arena",
  "block.minecraft.red_sand": "arena colorá",
  "block.minecraft.gravel": "çaorra",
  "block.minecraft.gold_ore": "beta d'oro",
  "block.minecraft.iron_ore": "beta de yerro",
  "block.minecraft.coal_ore": "beta de carbón",
  "block.minecraft.nether_gold_ore": "beta d'oro der nether",
  "block.minecraft.oak_log": "tronco de quehigo",
  "block.minecraft.spruce_log": "tronco de pinçapo",
  "block.minecraft.birch_log": "tronco de xopo",
  "block.minecraft.jungle_log": "tronco de hungla",
  "block.minecraft.acacia_log": "tronco de mimoça",
  "block.minecraft.dark_oak_log": "tronco de xaparro",
  "block.minecraft.crimson_stem": "tayo carmeçí",
  "block.minecraft.warped_stem": "tayo êttrambótico",
  "block.minecraft.stripped_oak_log": "tronco de quehigo çin corteça",
  "block.minecraft.stripped_spruce_log": "tronco de pinçapo çin corteça",
  "block.minecraft.stripped_birch_log": "tronco de xopo çin corteça",
  "block.minecraft.stripped_jungle_log": "tronco de hungla çin corteça",
  "block.minecraft.stripped_acacia_log": "tronco de mimoça çin corteça",
  "block.minecraft.stripped_dark_oak_log": "tronco de xaparro çin corteça",
  "block.minecraft.stripped_crimson_stem": "tayo carmeçí çin corteça",
  "block.minecraft.stripped_warped_stem": "tayo êttrambótico çin corteça",
  "block.minecraft.stripped_oak_wood": "leño de quehigo çin corteça",
  "block.minecraft.stripped_spruce_wood": "leño de pinçapo çin corteça",
  "block.minecraft.stripped_birch_wood": "leño de xopo çin corteça",
  "block.minecraft.stripped_jungle_wood": "leño de hungla çin corteça",
  "block.minecraft.stripped_acacia_wood": "leño de mimoça çin corteça",
  "block.minecraft.stripped_dark_oak_wood": "leño de xaparro çin corteça",
  "block.minecraft.stripped_crimson_hyphae": "ifâ carmeçîh çin corteça",
  "block.minecraft.stripped_warped_hyphae": "ifâ êttrambóticâ çin corteça",
  "block.minecraft.oak_wood": "leño de quehigo",
  "block.minecraft.spruce_wood": "leño de pinçapo",
  "block.minecraft.birch_wood": "leño de xopo",
  "block.minecraft.jungle_wood": "leño de hungla",
  "block.minecraft.acacia_wood": "leño de mimoça",
  "block.minecraft.dark_oak_wood": "leño de xaparro",
  "block.minecraft.crimson_hyphae": "ifâ carmeçîh",
  "block.minecraft.warped_hyphae": "ifâ êttrambóticâ",
  "block.minecraft.oak_leaves": "ohâ de quehigo",
  "block.minecraft.spruce_leaves": "ohâ de pinçapo",
  "block.minecraft.birch_leaves": "ohâ de xopo",
  "block.minecraft.jungle_leaves": "ohâ de hungla",
  "block.minecraft.acacia_leaves": "ohâ de mimoça",
  "block.minecraft.dark_oak_leaves": "ohâ de xaparro",
  "block.minecraft.sponge": "êpponha",
  "block.minecraft.wet_sponge": "êpponha mohá",
  "block.minecraft.glass": "crîttâh",
  "block.minecraft.lapis_ore": "beta de lapîl-láçuli",
  "block.minecraft.lapis_block": "bloque de lapîl-láçuli",
  "block.minecraft.dispenser": "dîppençadôh",
  "block.minecraft.sandstone": "arbero",
  "block.minecraft.chiseled_sandstone": "arbero êccurpío",
  "block.minecraft.cut_sandstone": "arbero cortao",
  "block.minecraft.note_block": "bloque muçicâh",
  "block.minecraft.powered_rail": "raîh propurçôh",
  "block.minecraft.detector_rail": "raîh detêttôh",
  "block.minecraft.sticky_piston": "pîttón pegahoço",
  "block.minecraft.cobweb": "telaraña",
  "block.minecraft.grass": "yerba",
  "block.minecraft.fern": "helexo",
  "block.minecraft.dead_bush": "arbûtto muerto",
  "block.minecraft.seagrass": "yerba marina",
  "block.minecraft.sea_pickle": "çipote / caraho de mâh",
  "block.minecraft.piston": "pîttón",
  "block.minecraft.white_wool": "lana blanca",
  "block.minecraft.orange_wool": "lana naranha",
  "block.minecraft.magenta_wool": "lana mahenta",
  "block.minecraft.light_blue_wool": "lana açûh claro",
  "block.minecraft.yellow_wool": "lana amariya",
  "block.minecraft.lime_wool": "lana lima",
  "block.minecraft.pink_wool": "lana roça",
  "block.minecraft.gray_wool": "lana grîh",
  "block.minecraft.light_gray_wool": "lana grîh claro",
  "block.minecraft.cyan_wool": "lana çian",
  "block.minecraft.purple_wool": "lana morá",
  "block.minecraft.blue_wool": "lana açûh",
  "block.minecraft.brown_wool": "lana marrón",
  "block.minecraft.green_wool": "lana berde",
  "block.minecraft.red_wool": "lana colorá",
  "block.minecraft.black_wool": "lana êccura",
  "block.minecraft.dandelion": "diente de león",
  "block.minecraft.poppy": "amapola",
  "block.minecraft.blue_orchid": "orquídia açûh",
  "block.minecraft.allium": "allium",
  "block.minecraft.azure_bluet": "rubiáçea",
  "block.minecraft.red_tulip": "tulipán colorao",
  "block.minecraft.orange_tulip": "tulipán naranha",
  "block.minecraft.white_tulip": "tulipán blanco",
  "block.minecraft.pink_tulip": "tulipán roça",
  "block.minecraft.oxeye_daisy": "margarita",
  "block.minecraft.cornflower": "açiano",
  "block.minecraft.lily_of_the_valley": "lirio der baye",
  "block.minecraft.wither_rose": "roça de wither",
  "block.minecraft.brown_mushroom": "gurumelo marrón",
  "block.minecraft.red_mushroom": "gurumelo colorao",
  "block.minecraft.crimson_fungus": "hongo carmeçí",
  "block.minecraft.warped_fungus": "hongo êttrambótico",
  "block.minecraft.crimson_roots": "raíçê carmeçíê",
  "block.minecraft.warped_roots": "raíçê êttrambóticâ",
  "block.minecraft.nether_sprouts": "brotê der nether",
  "block.minecraft.weeping_vines": "enreaera çoyoçante",
  "block.minecraft.twisting_vines": "enreaera retorçía",
  "block.minecraft.sugar_cane": "caña d'açúcâ",
  "block.minecraft.kelp": "arga",
  "block.minecraft.bamboo": "bambú",
  "block.minecraft.gold_block": "bloque d'oro",
  "block.minecraft.iron_block": "bloque de yerro",
  "block.minecraft.oak_slab": "bardoça de quehigo",
  "block.minecraft.spruce_slab": "bardoça de pinçapo",
  "block.minecraft.birch_slab": "bardoça de xopo",
  "block.minecraft.jungle_slab": "bardoça de hungla",
  "block.minecraft.acacia_slab": "bardoça de mimoça",
  "block.minecraft.dark_oak_slab": "bardoça de xaparro",
  "block.minecraft.crimson_slab": "bardoça carmeçí",
  "block.minecraft.warped_slab": "bardoça êttrambótica",
  "block.minecraft.stone_slab": "bardoça de roca",
  "block.minecraft.smooth_stone_slab": "bardoça de roca pulía",
  "block.minecraft.sandstone_slab": "bardoça d'arbero",
  "block.minecraft.cut_sandstone_slab": "bardoça d'arbero cortao",
  "block.minecraft.petrified_oak_slab": "bardoça de quehigo petrificao",
  "block.minecraft.cobblestone_slab": "bardoça d'adoquín",
  "block.minecraft.brick_slab": "bardoça de ladriyô",
  "block.minecraft.stone_brick_slab": "bardoça de ladriyô de roca",
  "block.minecraft.nether_brick_slab": "bardoça de ladriyô der nether",
  "block.minecraft.quartz_slab": "bardoça de cuarço",
  "block.minecraft.red_sandstone_slab": "bardoça d'arbero colorao",
  "block.minecraft.cut_red_sandstone_slab": "bardoça d'arbero colorao cortao",
  "block.minecraft.purpur_slab": "bardoça de púrpur",
  "block.minecraft.prismarine_slab": "bardoça de prîmmarina",
  "block.minecraft.prismarine_brick_slab": "bardoça de ladriyô de prîmmarina",
  "block.minecraft.dark_prismarine_slab": "bardoça de prîmmarina êccura",
  "block.minecraft.smooth_quartz": "bloque de cuarço pulío",
  "block.minecraft.smooth_red_sandstone": "arbero colorao pulío",
  "block.minecraft.smooth_sandstone": "arbero pulío",
  "block.minecraft.smooth_stone": "roca pulía",
  "block.minecraft.bricks": "ladriyô",
  "block.minecraft.tnt": "tnt",
  "block.minecraft.bookshelf": "anaquêh de librô",
  "block.minecraft.mossy_cobblestone": "adoquín mûggoço",
  "block.minecraft.obsidian": "ôççidiana",
  "block.minecraft.torch": "antorxa",
  "block.minecraft.end_rod": "bara del end",
  "block.minecraft.chorus_plant": "planta de chorus",
  "block.minecraft.chorus_flower": "flôh de chorus",
  "block.minecraft.purpur_block": "bloque de púrpur",
  "block.minecraft.purpur_pillar": "pilâh de púrpur",
  "block.minecraft.purpur_stairs": "êccalerâ de púrpur",
  "block.minecraft.spawner": "heneradôh",
  "block.minecraft.oak_stairs": "êccalerâ de quehigo",
  "block.minecraft.chest": "baûh",
  "block.minecraft.diamond_ore": "beta de diamante",
  "block.minecraft.diamond_block": "bloque de diamante",
  "block.minecraft.crafting_table": "meça de crâtteo",
  "block.minecraft.farmland": "tierra de curtibo",
  "block.minecraft.furnace": "hônno",
  "block.minecraft.ladder": "êccalera de mano",
  "block.minecraft.rail": "raîh",
  "block.minecraft.cobblestone_stairs": "êccalerâ d'adoquín",
  "block.minecraft.lever": "palanca",
  "block.minecraft.stone_pressure_plate": "placa de preçión de roca",
  "block.minecraft.oak_pressure_plate": "placa de preçión de quehigo",
  "block.minecraft.spruce_pressure_plate": "placa de preçión de pinçapo",
  "block.minecraft.birch_pressure_plate": "placa de preçión de xopo",
  "block.minecraft.jungle_pressure_plate": "placa de preçión de hungla",
  "block.minecraft.acacia_pressure_plate": "placa de preçión de mimoça",
  "block.minecraft.dark_oak_pressure_plate": "placa de preçión de xaparro",
  "block.minecraft.crimson_pressure_plate": "placa de preçión carmeçí",
  "block.minecraft.warped_pressure_plate": "placa de preçión êttrambótica",
  "block.minecraft.polished_blackstone_pressure_plate": "placa de preçión d'açabaxe pulío",
  "block.minecraft.redstone_ore": "beta de redstone",
  "block.minecraft.redstone_torch": "antorxa de redstone",
  "block.minecraft.snow": "niebe",
  "block.minecraft.ice": "yelo",
  "block.minecraft.snow_block": "bloque de niebe",
  "block.minecraft.cactus": "câttû",
  "block.minecraft.clay": "arçiya",
  "block.minecraft.jukebox": "tocadîccô",
  "block.minecraft.oak_fence": "berha de quehigo",
  "block.minecraft.spruce_fence": "berha de pinçapo",
  "block.minecraft.birch_fence": "berha de xopo",
  "block.minecraft.jungle_fence": "berha de hungla",
  "block.minecraft.acacia_fence": "berha de mimoça",
  "block.minecraft.dark_oak_fence": "berha de xaparro",
  "block.minecraft.crimson_fence": "berha carmeçí",
  "block.minecraft.warped_fence": "berha êttrambótica",
  "block.minecraft.pumpkin": "calabaça",
  "block.minecraft.carved_pumpkin": "calabaça tayá",
  "block.minecraft.netherrack": "netherrack",
  "block.minecraft.soul_sand": "arena d'ánimâ",
  "block.minecraft.soul_soil": "tierra d'ánimâ",
  "block.minecraft.basalt": "baçarto",
  "block.minecraft.polished_basalt": "baçarto pulío",
  "block.minecraft.soul_torch": "antorxa d'ánimâ",
  "block.minecraft.glowstone": "roca briyante",
  "block.minecraft.jack_o_lantern": "calabaça de toçantô / çamaín",
  "block.minecraft.oak_trapdoor": "trampiya de quehigo",
  "block.minecraft.spruce_trapdoor": "trampiya de pinçapo",
  "block.minecraft.birch_trapdoor": "trampiya de xopo",
  "block.minecraft.jungle_trapdoor": "trampiya de hungla",
  "block.minecraft.acacia_trapdoor": "trampiya de mimoça",
  "block.minecraft.dark_oak_trapdoor": "trampiya de xaparro",
  "block.minecraft.crimson_trapdoor": "trampiya carmeçí",
  "block.minecraft.warped_trapdoor": "trampiya êttrambótica",
  "block.minecraft.infested_stone": "roca infêttá",
  "block.minecraft.infested_cobblestone": "adoquín infêttáo",
  "block.minecraft.infested_stone_bricks": "ladriyô de roca infêttá",
  "block.minecraft.infested_mossy_stone_bricks": "ladriyô de roca mûggoça infêttá",
  "block.minecraft.infested_cracked_stone_bricks": "ladriyô de roca rêqquebrahá infêttá",
  "block.minecraft.infested_chiseled_stone_bricks": "ladriyô de roca êccurpía infêttá",
  "block.minecraft.stone_bricks": "ladriyô de roca",
  "block.minecraft.mossy_stone_bricks": "ladriyô de roca mûggoça",
  "block.minecraft.cracked_stone_bricks": "ladriyô de roca rêqquebrahá",
  "block.minecraft.chiseled_stone_bricks": "ladriyô de roca êccurpía",
  "block.minecraft.brown_mushroom_block": "bloque de gurumelo marrón",
  "block.minecraft.red_mushroom_block": "bloque de gurumelo colorao",
  "block.minecraft.mushroom_stem": "tayo de gurumelo",
  "block.minecraft.iron_bars": "barrotê de yerro",
  "block.minecraft.chain": "caena",
  "block.minecraft.glass_pane": "panêh de crîttâh",
  "block.minecraft.melon": "açendía",
  "block.minecraft.vine": "enreaera",
  "block.minecraft.oak_fence_gate": "cançela de quehigo",
  "block.minecraft.spruce_fence_gate": "cançela de pinçapo",
  "block.minecraft.birch_fence_gate": "cançela de xopo",
  "block.minecraft.jungle_fence_gate": "cançela de hungla",
  "block.minecraft.acacia_fence_gate": "cançela de mimoça",
  "block.minecraft.dark_oak_fence_gate": "cançela de xaparro",
  "block.minecraft.crimson_fence_gate": "cançela carmeçí",
  "block.minecraft.warped_fence_gate": "cançela êttrambótica",
  "block.minecraft.brick_stairs": "êccalerâ de ladriyô",
  "block.minecraft.stone_brick_stairs": "êccalerâ de ladriyô de roca",
  "block.minecraft.mycelium": "miçelio",
  "block.minecraft.lily_pad": "nenúfâ",
  "block.minecraft.nether_bricks": "ladriyô der nether",
  "block.minecraft.cracked_nether_bricks": "ladriyô der nether rêqquebrahaô",
  "block.minecraft.chiseled_nether_bricks": "ladriyô der nether êccurpíô",
  "block.minecraft.nether_brick_fence": "berha de ladriyô der nether",
  "block.minecraft.nether_brick_stairs": "êccalerâ de ladriyô der nether",
  "block.minecraft.enchanting_table": "meça d'encantamientô",
  "block.minecraft.end_portal_frame": "marco der portâh del end",
  "block.minecraft.end_stone": "roca del end",
  "block.minecraft.end_stone_bricks": "ladriyô de roca del end",
  "block.minecraft.dragon_egg": "guebo de dragón",
  "block.minecraft.redstone_lamp": "lámpara de redstone",
  "block.minecraft.sandstone_stairs": "êccalerâ d'arbero",
  "block.minecraft.emerald_ore": "beta d'êmmerarda",
  "block.minecraft.ender_chest": "baûh d'ender",
  "block.minecraft.tripwire_hook": "ganxo de cordêh trampa",
  "block.minecraft.emerald_block": "bloque d'êmmerarda",
  "block.minecraft.spruce_stairs": "êccalerâ de pinçapo",
  "block.minecraft.birch_stairs": "êccalerâ de xopo",
  "block.minecraft.jungle_stairs": "êccalerâ de hungla",
  "block.minecraft.crimson_stairs": "êccalerâ carmeçíê",
  "block.minecraft.warped_stairs": "êccalerâ êttrambóticâ",
  "block.minecraft.command_block": "bloque de comandô",
  "block.minecraft.beacon": "faro",
  "block.minecraft.cobblestone_wall": "muro d'adoquín",
  "block.minecraft.mossy_cobblestone_wall": "muro d'adoquín mûggoço",
  "block.minecraft.brick_wall": "muro de ladriyô",
  "block.minecraft.prismarine_wall": "muro de prîmmarina",
  "block.minecraft.red_sandstone_wall": "muro d'arbero colorao",
  "block.minecraft.mossy_stone_brick_wall": "muro de ladriyô de roca mûggoça",
  "block.minecraft.granite_wall": "muro de granito",
  "block.minecraft.stone_brick_wall": "muro de ladriyô de roca",
  "block.minecraft.nether_brick_wall": "muro de ladriyô der nether",
  "block.minecraft.andesite_wall": "muro d'andeçita",
  "block.minecraft.red_nether_brick_wall": "muro de ladriyô der nether coloraô",
  "block.minecraft.sandstone_wall": "muro d'arbero",
  "block.minecraft.end_stone_brick_wall": "muro de ladriyô de roca del end",
  "block.minecraft.diorite_wall": "muro de diorita",
  "block.minecraft.blackstone_wall": "muro d'açabaxe",
  "block.minecraft.polished_blackstone_wall": "muro d'açabaxe pulío",
  "block.minecraft.polished_blackstone_brick_wall": "muro de ladriyô d'açabaxe pulío",
  "block.minecraft.stone_button": "botón de roca",
  "block.minecraft.oak_button": "botón de quehigo",
  "block.minecraft.spruce_button": "botón de pinçapo",
  "block.minecraft.birch_button": "botón de xopo",
  "block.minecraft.jungle_button": "botón de hungla",
  "block.minecraft.acacia_button": "botón de mimoça",
  "block.minecraft.dark_oak_button": "botón de xaparro",
  "block.minecraft.crimson_button": "botón carmeçí",
  "block.minecraft.warped_button": "botón êttrambótico",
  "block.minecraft.polished_blackstone_button": "botón d'açabaxe pulío",
  "block.minecraft.anvil": "yunque",
  "block.minecraft.chipped_anvil": "yunque êcconxao",
  "block.minecraft.damaged_anvil": "yunque mu dañao",
  "block.minecraft.trapped_chest": "baûh trampa",
  "block.minecraft.light_weighted_pressure_plate": "placa de preçión pa peço lihero",
  "block.minecraft.heavy_weighted_pressure_plate": "placa de preçión pa peço elebao",
  "block.minecraft.daylight_detector": "çençôh de lûh çolâh",
  "block.minecraft.redstone_block": "bloque de redstone",
  "block.minecraft.nether_quartz_ore": "beta de cuarço der nether",
  "block.minecraft.hopper": "torba",
  "block.minecraft.chiseled_quartz_block": "cuarço êccurpío",
  "block.minecraft.quartz_block": "bloque de cuarço",
  "block.minecraft.quartz_bricks": "ladriyô de cuarço",
  "block.minecraft.quartz_pillar": "pilâh de cuarço",
  "block.minecraft.quartz_stairs": "êccalerâ de cuarço",
  "block.minecraft.activator_rail": "raîh âttibadôh",
  "block.minecraft.dropper": "çortadôh",
  "block.minecraft.white_terracotta": "terracota blanca",
  "block.minecraft.orange_terracotta": "terracota naranha",
  "block.minecraft.magenta_terracotta": "terracota mahenta",
  "block.minecraft.light_blue_terracotta": "terracota açûh claro",
  "block.minecraft.yellow_terracotta": "terracota amariya",
  "block.minecraft.lime_terracotta": "terracota lima",
  "block.minecraft.pink_terracotta": "terracota roça",
  "block.minecraft.gray_terracotta": "terracota grîh",
  "block.minecraft.light_gray_terracotta": "terracota grîh claro",
  "block.minecraft.cyan_terracotta": "terracota çian",
  "block.minecraft.purple_terracotta": "terracota morá",
  "block.minecraft.blue_terracotta": "terracota açûh",
  "block.minecraft.brown_terracotta": "terracota marrón",
  "block.minecraft.green_terracotta": "terracota berde",
  "block.minecraft.red_terracotta": "terracota colorá",
  "block.minecraft.black_terracotta": "terracota êccura",
  "block.minecraft.barrier": "barrera",
  "block.minecraft.iron_trapdoor": "trampiya de yerro",
  "block.minecraft.hay_block": "arpaca de paha",
  "block.minecraft.white_carpet": "arfombra blanca",
  "block.minecraft.orange_carpet": "arfombra naranha",
  "block.minecraft.magenta_carpet": "arfombra mahenta",
  "block.minecraft.light_blue_carpet": "arfombra açûh claro",
  "block.minecraft.yellow_carpet": "arfombra amariya",
  "block.minecraft.lime_carpet": "arfombra lima",
  "block.minecraft.pink_carpet": "arfombra roça",
  "block.minecraft.gray_carpet": "arfombra grîh",
  "block.minecraft.light_gray_carpet": "arfombra grîh claro",
  "block.minecraft.cyan_carpet": "arfombra çian",
  "block.minecraft.purple_carpet": "arfombra morá",
  "block.minecraft.blue_carpet": "arfombra açûh",
  "block.minecraft.brown_carpet": "arfombra marrón",
  "block.minecraft.green_carpet": "arfombra berde",
  "block.minecraft.red_carpet": "arfombra colorá",
  "block.minecraft.black_carpet": "arfombra êccura",
  "block.minecraft.terracotta": "terracota",
  "block.minecraft.coal_block": "bloque de carbón",
  "block.minecraft.packed_ice": "yelo compâttao",
  "block.minecraft.acacia_stairs": "êccalerâ de mimoça",
  "block.minecraft.dark_oak_stairs": "êccalerâ de xaparro",
  "block.minecraft.slime_block": "bloque de limo",
  "block.minecraft.grass_path": "camino de yerba",
  "block.minecraft.sunflower": "hiraçôh",
  "block.minecraft.lilac": "lila",
  "block.minecraft.rose_bush": "roçâh",
  "block.minecraft.peony": "peonía",
  "block.minecraft.tall_grass": "yerba arta",
  "block.minecraft.large_fern": "helexo grande",
  "block.minecraft.white_stained_glass": "crîttâh tintao de blanco",
  "block.minecraft.orange_stained_glass": "crîttâh tintao de naranha",
  "block.minecraft.magenta_stained_glass": "crîttâh tintao de mahenta",
  "block.minecraft.light_blue_stained_glass": "crîttâh tintao d'açûh claro",
  "block.minecraft.yellow_stained_glass": "crîttâh tintao d'amariyo",
  "block.minecraft.lime_stained_glass": "crîttâh tintao de lima",
  "block.minecraft.pink_stained_glass": "crîttâh tintao de roça",
  "block.minecraft.gray_stained_glass": "crîttâh tintao de grîh",
  "block.minecraft.light_gray_stained_glass": "crîttâh tintao de grîh claro",
  "block.minecraft.cyan_stained_glass": "crîttâh tintao de çian",
  "block.minecraft.purple_stained_glass": "crîttâh tintao de morao",
  "block.minecraft.blue_stained_glass": "crîttâh tintao d'açûh",
  "block.minecraft.brown_stained_glass": "crîttâh tintao de marrón",
  "block.minecraft.green_stained_glass": "crîttâh tintao de berde",
  "block.minecraft.red_stained_glass": "crîttâh tintao de colorao",
  "block.minecraft.black_stained_glass": "crîttâh tintao d'êccuro",
  "block.minecraft.white_stained_glass_pane": "panêh de crîttâh tintao de blanco",
  "block.minecraft.orange_stained_glass_pane": "panêh de crîttâh tintao de naranha",
  "block.minecraft.magenta_stained_glass_pane": "panêh de crîttâh tintao de mahenta",
  "block.minecraft.light_blue_stained_glass_pane": "panêh de crîttâh tintao d'açûh claro",
  "block.minecraft.yellow_stained_glass_pane": "panêh de crîttâh tintao d'amariyo",
  "block.minecraft.lime_stained_glass_pane": "panêh de crîttâh tintao de lima",
  "block.minecraft.pink_stained_glass_pane": "panêh de crîttâh tintao de roça",
  "block.minecraft.gray_stained_glass_pane": "panêh de crîttâh tintao de grîh",
  "block.minecraft.light_gray_stained_glass_pane": "panêh de crîttâh tintao de grîh claro",
  "block.minecraft.cyan_stained_glass_pane": "panêh de crîttâh tintao de çian",
  "block.minecraft.purple_stained_glass_pane": "panêh de crîttâh tintao de morao",
  "block.minecraft.blue_stained_glass_pane": "panêh de crîttâh tintao d'açûh",
  "block.minecraft.brown_stained_glass_pane": "panêh de crîttâh tintao de marrón",
  "block.minecraft.green_stained_glass_pane": "panêh de crîttâh tintao de berde",
  "block.minecraft.red_stained_glass_pane": "panêh de crîttâh tintao de colorao",
  "block.minecraft.black_stained_glass_pane": "panêh de crîttâh tintao d'êccuro",
  "block.minecraft.prismarine": "prîmmarina",
  "block.minecraft.prismarine_bricks": "ladriyô de prîmmarina",
  "block.minecraft.dark_prismarine": "prîmmarina êccura",
  "block.minecraft.prismarine_stairs": "êccalerâ de prîmmarina",
  "block.minecraft.prismarine_brick_stairs": "êccalerâ de ladriyô de prîmmarina",
  "block.minecraft.dark_prismarine_stairs": "êccalerâ de prîmmarina êccura",
  "block.minecraft.sea_lantern": "lintênna marina",
  "block.minecraft.red_sandstone": "arbero colorao",
  "block.minecraft.chiseled_red_sandstone": "arbero colorao êccurpío",
  "block.minecraft.cut_red_sandstone": "arbero colorao cortao",
  "block.minecraft.red_sandstone_stairs": "êccalerâ d'arbero colorao",
  "block.minecraft.repeating_command_block": "bloque de comandô iteratibo",
  "block.minecraft.chain_command_block": "bloque de comandô en cadena",
  "block.minecraft.magma_block": "bloque de mâmma",
  "block.minecraft.nether_wart_block": "bloque de berrugâ der nether",
  "block.minecraft.warped_wart_block": "bloque de berrugâ êttrambóticâ",
  "block.minecraft.red_nether_bricks": "ladriyô der nether coloraô",
  "block.minecraft.bone_block": "bloque de gueço",
  "block.minecraft.structure_void": "baçío êttrûtturâh",
  "block.minecraft.observer": "ôççerbadôh",
  "block.minecraft.shulker_box": "caha de shulker",
  "block.minecraft.white_shulker_box": "caha de shulker blanca",
  "block.minecraft.orange_shulker_box": "caha de shulker naranha",
  "block.minecraft.magenta_shulker_box": "caha de shulker mahenta",
  "block.minecraft.light_blue_shulker_box": "caha de shulker açûh claro",
  "block.minecraft.yellow_shulker_box": "caha de shulker amariya",
  "block.minecraft.lime_shulker_box": "caha de shulker lima",
  "block.minecraft.pink_shulker_box": "caha de shulker roça",
  "block.minecraft.gray_shulker_box": "caha de shulker grîh",
  "block.minecraft.light_gray_shulker_box": "caha de shulker grîh claro",
  "block.minecraft.cyan_shulker_box": "caha de shulker çian",
  "block.minecraft.purple_shulker_box": "caha de shulker morá",
  "block.minecraft.blue_shulker_box": "caha de shulker açûh",
  "block.minecraft.brown_shulker_box": "caha de shulker marrón",
  "block.minecraft.green_shulker_box": "caha de shulker berde",
  "block.minecraft.red_shulker_box": "caha de shulker colorá",
  "block.minecraft.black_shulker_box": "caha de shulker êccura",
  "block.minecraft.white_glazed_terracotta": "açuleho blanco",
  "block.minecraft.orange_glazed_terracotta": "açuleho naranha",
  "block.minecraft.magenta_glazed_terracotta": "açuleho mahenta",
  "block.minecraft.light_blue_glazed_terracotta": "açuleho açûh claro",
  "block.minecraft.yellow_glazed_terracotta": "açuleho amariyo",
  "block.minecraft.lime_glazed_terracotta": "açuleho lima",
  "block.minecraft.pink_glazed_terracotta": "açuleho roça",
  "block.minecraft.gray_glazed_terracotta": "açuleho grîh",
  "block.minecraft.light_gray_glazed_terracotta": "açuleho grîh claro",
  "block.minecraft.cyan_glazed_terracotta": "açuleho çian",
  "block.minecraft.purple_glazed_terracotta": "açuleho morao",
  "block.minecraft.blue_glazed_terracotta": "açuleho açûh",
  "block.minecraft.brown_glazed_terracotta": "açuleho marrón",
  "block.minecraft.green_glazed_terracotta": "açuleho berde",
  "block.minecraft.red_glazed_terracotta": "açuleho colorao",
  "block.minecraft.black_glazed_terracotta": "açuleho êccuro",
  "block.minecraft.white_concrete": "hormigón blanco",
  "block.minecraft.orange_concrete": "hormigón naranha",
  "block.minecraft.magenta_concrete": "hormigón mahenta",
  "block.minecraft.light_blue_concrete": "hormigón açûh claro",
  "block.minecraft.yellow_concrete": "hormigón amariyo",
  "block.minecraft.lime_concrete": "hormigón lima",
  "block.minecraft.pink_concrete": "hormigón roça",
  "block.minecraft.gray_concrete": "hormigón grîh",
  "block.minecraft.light_gray_concrete": "hormigón grîh claro",
  "block.minecraft.cyan_concrete": "hormigón çian",
  "block.minecraft.purple_concrete": "hormigón morao",
  "block.minecraft.blue_concrete": "hormigón açûh",
  "block.minecraft.brown_concrete": "hormigón marrón",
  "block.minecraft.green_concrete": "hormigón berde",
  "block.minecraft.red_concrete": "hormigón colorao",
  "block.minecraft.black_concrete": "hormigón êccuro",
  "block.minecraft.white_concrete_powder": "çemento blanco",
  "block.minecraft.orange_concrete_powder": "çemento naranha",
  "block.minecraft.magenta_concrete_powder": "çemento mahenta",
  "block.minecraft.light_blue_concrete_powder": "çemento açûh claro",
  "block.minecraft.yellow_concrete_powder": "çemento amariyo",
  "block.minecraft.lime_concrete_powder": "çemento lima",
  "block.minecraft.pink_concrete_powder": "çemento roça",
  "block.minecraft.gray_concrete_powder": "çemento grîh",
  "block.minecraft.light_gray_concrete_powder": "çemento grîh claro",
  "block.minecraft.cyan_concrete_powder": "çemento çian",
  "block.minecraft.purple_concrete_powder": "çemento morao",
  "block.minecraft.blue_concrete_powder": "çemento açûh",
  "block.minecraft.brown_concrete_powder": "çemento marrón",
  "block.minecraft.green_concrete_powder": "çemento berde",
  "block.minecraft.red_concrete_powder": "çemento colorao",
  "block.minecraft.black_concrete_powder": "çemento êccuro",
  "block.minecraft.turtle_egg": "guebo de tortuga",
  "block.minecraft.dead_tube_coral_block": "bloque de corâh de tubo muerto",
  "block.minecraft.dead_brain_coral_block": "bloque de corâh de çerebro muerto",
  "block.minecraft.dead_bubble_coral_block": "bloque de corâh de burbuha muerto",
  "block.minecraft.dead_fire_coral_block": "bloque de corâh de fuego muerto",
  "block.minecraft.dead_horn_coral_block": "bloque de corâh de cuênno muerto",
  "block.minecraft.tube_coral_block": "bloque de corâh de tubo",
  "block.minecraft.brain_coral_block": "bloque de corâh de çerebro",
  "block.minecraft.bubble_coral_block": "bloque de corâh de burbuha",
  "block.minecraft.fire_coral_block": "bloque de corâh de fuego",
  "block.minecraft.horn_coral_block": "bloque de corâh de cuênno",
  "block.minecraft.tube_coral": "corâh de tubo",
  "block.minecraft.brain_coral": "corâh de çerebro",
  "block.minecraft.bubble_coral": "corâh de burbuhâ",
  "block.minecraft.fire_coral": "corâh de fuego",
  "block.minecraft.horn_coral": "corâh de cuênno",
  "block.minecraft.dead_brain_coral": "corâh de çerebro muerto",
  "block.minecraft.dead_bubble_coral": "corâh de burbuha muerto",
  "block.minecraft.dead_fire_coral": "corâh de fuego muerto",
  "block.minecraft.dead_horn_coral": "corâh de cuênno muerto",
  "block.minecraft.dead_tube_coral": "corâh de tubo muerto",
  "block.minecraft.tube_coral_fan": "gorgonia de tubo",
  "block.minecraft.brain_coral_fan": "gorgonia de çerebro",
  "block.minecraft.bubble_coral_fan": "gorgonia de burbuha",
  "block.minecraft.fire_coral_fan": "gorgonia de fuego",
  "block.minecraft.horn_coral_fan": "gorgonia de cuênno",
  "block.minecraft.dead_tube_coral_fan": "gorgonia de tubo muerta",
  "block.minecraft.dead_brain_coral_fan": "gorgonia de çerebro muerta",
  "block.minecraft.dead_bubble_coral_fan": "gorgonia de burbuha muerta",
  "block.minecraft.dead_fire_coral_fan": "gorgonia de fuego muerta",
  "block.minecraft.dead_horn_coral_fan": "gorgonia de cuênno muerta",
  "block.minecraft.blue_ice": "yelo açûh",
  "block.minecraft.conduit": "canaliçadôh",
  "block.minecraft.polished_granite_stairs": "êccalerâ de granito pulío",
  "block.minecraft.smooth_red_sandstone_stairs": "êccalerâ d'arbero colorao pulío",
  "block.minecraft.mossy_stone_brick_stairs": "êccalerâ de ladriyô de roca mûggoça",
  "block.minecraft.polished_diorite_stairs": "êccalerâ de diorita pulía",
  "block.minecraft.mossy_cobblestone_stairs": "êccalerâ d'adoquín mûggoço",
  "block.minecraft.end_stone_brick_stairs": "êccalerâ de ladriyô de roca del end",
  "block.minecraft.stone_stairs": "êccalerâ de roca",
  "block.minecraft.smooth_sandstone_stairs": "êccalerâ d'arbero pulío",
  "block.minecraft.smooth_quartz_stairs": "êccalerâ de cuarço pulío",
  "block.minecraft.granite_stairs": "êccalerâ de granito",
  "block.minecraft.andesite_stairs": "êccalerâ d'andeçita",
  "block.minecraft.red_nether_brick_stairs": "êccalerâ de ladriyô der nether coloraô",
  "block.minecraft.polished_andesite_stairs": "êccalerâ d'andeçita pulía",
  "block.minecraft.diorite_stairs": "êccalerâ de diorita",
  "block.minecraft.polished_granite_slab": "bardoça de granito pulío",
  "block.minecraft.smooth_red_sandstone_slab": "bardoça d'arbero coloráo pulío",
  "block.minecraft.mossy_stone_brick_slab": "bardoça de ladriyô de roca mûggoça",
  "block.minecraft.polished_diorite_slab": "bardoça de diorita pulía",
  "block.minecraft.mossy_cobblestone_slab": "bardoça d'adoquín mûggoço",
  "block.minecraft.end_stone_brick_slab": "bardoça de ladriyô de roca del end",
  "block.minecraft.smooth_sandstone_slab": "bardoça d'arbero pulío",
  "block.minecraft.smooth_quartz_slab": "bardoça de cuarço pulío",
  "block.minecraft.granite_slab": "bardoça de granito",
  "block.minecraft.andesite_slab": "bardoça d'andeçita",
  "block.minecraft.red_nether_brick_slab": "bardoça de ladriyô der nether coloraô",
  "block.minecraft.polished_andesite_slab": "bardoça d'andeçita pulía",
  "block.minecraft.diorite_slab": "bardoça de diorita",
  "block.minecraft.scaffolding": "andamio",
  "block.minecraft.iron_door": "puerta de yerro",
  "block.minecraft.oak_door": "puerta de quehigo",
  "block.minecraft.spruce_door": "puerta de pinçapo",
  "block.minecraft.birch_door": "puerta de xopo",
  "block.minecraft.jungle_door": "puerta de hungla",
  "block.minecraft.acacia_door": "puerta de mimoça",
  "block.minecraft.dark_oak_door": "puerta de xaparro",
  "block.minecraft.crimson_door": "puerta carmeçí",
  "block.minecraft.warped_door": "puerta êttrambótica",
  "block.minecraft.repeater": "repetidôh de redstone",
  "block.minecraft.comparator": "comparadôh de redstone",
  "block.minecraft.structure_block": "bloque êttrûtturâh",
  "block.minecraft.jigsaw": "bloque rompecabeçâ",
  "item.minecraft.turtle_helmet": "caparaçón de tortuga□□en la cabeça:□+2 armaúra",
  "item.minecraft.scute": "êccama de tortuga",
  "item.minecraft.iron_shovel": "pala de yerro□□en la mano prinçipâh:□+3.5 daño d'ataque□-3 beloçidá d'ataque",
  "item.minecraft.iron_pickaxe": "êppioxa de yerro□□en la mano prinçipâh:□+3 daño d'ataque□-2.8 beloçidá d'ataque",
  "item.minecraft.iron_axe": "haxa de yerro□□en la mano prinçipâh:□+8 daño d'ataque□-3.1 beloçidá d'ataque",
  "item.minecraft.flint_and_steel": "ençendedôh",
  "item.minecraft.apple": "pero",
  "item.minecraft.bow": "arco",
  "item.minecraft.arrow": "flexa",
  "item.minecraft.coal": "carbón",
  "item.minecraft.charcoal": "carbón behetâh",
  "item.minecraft.diamond": "diamante",
  "item.minecraft.iron_ingot": "lingote de yerro",
  "item.minecraft.gold_ingot": "lingote d'oro",
  "item.minecraft.netherite_ingot": "lingote de netherita",
  "item.minecraft.netherite_scrap": "êccoria de netherita",
  "item.minecraft.iron_sword": "êppá de yerro□□en la mano prinçipâh:□+5 daño d'ataque□-2.4 beloçidá d'ataque",
  "item.minecraft.wooden_sword": "êppá de maera□□en la mano prinçipâh:□+3 daño d'ataque□-2.4 beloçidá d'ataque",
  "item.minecraft.wooden_shovel": "pala de maera□□en la mano prinçipâh:□+1.5 daño d'ataque□-3 beloçidá d'ataque",
  "item.minecraft.wooden_pickaxe": "êppioxa de maera□□en la mano prinçipâh:□+1 daño d'ataque□-2.8 beloçidá d'ataque",
  "item.minecraft.wooden_axe": "haxa de maera□□en la mano prinçipâh:□+6 daño d'ataque□-3.2 beloçidá d'ataque",
  "item.minecraft.stone_sword": "êppá de piedra□□en la mano prinçipâh:□+4 daño d'ataque□-2.4 beloçidá d'ataque",
  "item.minecraft.stone_shovel": "pala de piedra□□en la mano prinçipâh:□+2.5 daño d'ataque□-3 beloçidá d'ataque",
  "item.minecraft.stone_pickaxe": "êppioxa de piedra□□en la mano prinçipâh:□+2 daño d'ataque□-2.8 beloçidá d'ataque",
  "item.minecraft.stone_axe": "haxa de piedra□□en la mano prinçipâh:□+8 daño d'ataque□-3.2 beloçidá d'ataque",
  "item.minecraft.diamond_sword": "êppá de diamante□□en la mano prinçipâh:□+6 daño d'ataque□-2.4 beloçidá d'ataque",
  "item.minecraft.diamond_shovel": "pala de diamante□□en la mano prinçipâh:□+4.5 daño d'ataque□-3 beloçidá d'ataque",
  "item.minecraft.diamond_pickaxe": "êppioxa de diamante□□en la mano prinçipâh:□+4 daño d'ataque□-2.8 beloçidá d'ataque",
  "item.minecraft.diamond_axe": "haxa de diamante□□en la mano prinçipâh:□+8 daño d'ataque□-3 beloçidá d'ataque",
  "item.minecraft.stick": "tarama / palo",
  "item.minecraft.bowl": "taçón",
  "item.minecraft.mushroom_stew": "giço de gurumelô",
  "item.minecraft.golden_sword": "êppá d'oro□□en la mano prinçipâh:□+3 daño d'ataque□-2.4 beloçidá d'ataque",
  "item.minecraft.golden_shovel": "pala d'oro□□en la mano prinçipâh:□+1.5 daño d'ataque□-3 beloçidá d'ataque",
  "item.minecraft.golden_pickaxe": "êppioxa d'oro□□en la mano prinçipâh:□+1 daño d'ataque□-2.8 beloçidá d'ataque",
  "item.minecraft.golden_axe": "haxa d'oro□□en la mano prinçipâh:□+6 daño d'ataque□-3 beloçidá d'ataque",
  "item.minecraft.netherite_sword": "êppá de netherita□□en la mano prinçipâh:□+7 daño d'ataque□-2.4 beloçidá d'ataque",
  "item.minecraft.netherite_shovel": "pala de netherita□□en la mano prinçipâh:□+5.5 daño d'ataque□-3 beloçidá d'ataque",
  "item.minecraft.netherite_pickaxe": "êppioxa de netherita□□en la mano prinçipâh:□+5 daño d'ataque□-2.8 beloçidá d'ataque",
  "item.minecraft.netherite_axe": "haxa de netherita□□en la mano prinçipâh:□+9 daño d'ataque□-3 beloçidá d'ataque",
  "item.minecraft.string": "cordêh",
  "item.minecraft.feather": "pluma",
  "item.minecraft.gunpowder": "pórbora",
  "item.minecraft.wooden_hoe": "çoleta de maera□□en la mano prinçipâh:□-3 beloçidá d'ataque",
  "item.minecraft.stone_hoe": "çoleta de piedra□□en la mano prinçipâh:□-2 beloçidá d'ataque",
  "item.minecraft.iron_hoe": "çoleta de yerro□□en la mano prinçipâh:□-1 beloçidá d'ataque",
  "item.minecraft.diamond_hoe": "çoleta de diamante□□en la mano prinçipâh:",
  "item.minecraft.golden_hoe": "çoleta d'oro□□en la mano prinçipâh:□-3 beloçidá d'ataque",
  "item.minecraft.netherite_hoe": "çoleta de netherita□□en la mano prinçipâh:",
  "item.minecraft.wheat_seeds": "çemiyâ de trigo",
  "item.minecraft.wheat": "trigo",
  "item.minecraft.bread": "pan",
  "item.minecraft.leather_helmet": "gorro de cuero□□en la cabeça:□+1 armaúra",
  "item.minecraft.leather_chestplate": "túnica de cuero□□n'er cuerpo:□+3 armaúra",
  "item.minecraft.leather_leggings": "pênnerâ de cuero□□en lâ piênnâ:□+2 armaúra",
  "item.minecraft.leather_boots": "botâ de cuero□□en lô pinrelê:□+1 armaúra",
  "item.minecraft.chainmail_helmet": "câcco de cota de maya□□en la cabeça:□+2 armaúra",
  "item.minecraft.chainmail_chestplate": "pexera de cota de maya□□n'er cuerpo:□+5 armaúra",
  "item.minecraft.chainmail_leggings": "grebâ de cota de maya□□en lâ piênnâ:□+4 armaúra",
  "item.minecraft.chainmail_boots": "botâ de cota de maya□□en lô pinrelê:□+1 armaúra",
  "item.minecraft.iron_helmet": "câcco de yerro□□en la cabeça:□+2 armaúra",
  "item.minecraft.iron_chestplate": "pexera de yerro□□n'er cuerpo:□+6 armaúra",
  "item.minecraft.iron_leggings": "grebâ de yerro□□en lâ piênnâ:□+5 armaúra",
  "item.minecraft.iron_boots": "botâ de yerro□□en lô pinrelê:□+2 armaúra",
  "item.minecraft.diamond_helmet": "câcco de diamante□□en la cabeça:□+3 armaúra□+2 dureça de armaúra",
  "item.minecraft.diamond_chestplate": "pexera de diamante□□n'er cuerpo:□+8 armaúra□+2 dureça de armaúra",
  "item.minecraft.diamond_leggings": "grebâ de diamante□□en lâ piênnâ:□+6 armaúra□+2 dureça de armaúra",
  "item.minecraft.diamond_boots": "botâ de diamante□□en lô pinrelê:□+3 armaúra□+2 dureça de armaúra",
  "item.minecraft.golden_helmet": "câcco d'oro□□en la cabeça:□+2 armaúra",
  "item.minecraft.golden_chestplate": "pexera d'oro□□n'er cuerpo:□+5 armaúra",
  "item.minecraft.golden_leggings": "grebâ d'oro□□en lâ piênnâ:□+3 armaúra",
  "item.minecraft.golden_boots": "botâ d'oro□□en lô pinrelê:□+1 armaúra",
  "item.minecraft.netherite_helmet": "câcco de netherita□□en la cabeça:□+3 armaúra□+3 dureça de armaúra□+1 reçîttençia al empuhe",
  "item.minecraft.netherite_chestplate": "pexera de netherita□□n'er cuerpo:□+8 armaúra□+3 dureça de armaúra□+1 reçîttençia al empuhe",
  "item.minecraft.netherite_leggings": "grebâ de netherita□□en lâ piênnâ:□+6 armaúra□+3 dureça de armaúra□+1 reçîttençia al empuhe",
  "item.minecraft.netherite_boots": "botâ de netherita□□en lô pinrelê:□+3 armaúra□+3 dureça de armaúra□+1 reçîttençia al empuhe",
  "item.minecraft.flint": "pedênnâh",
  "item.minecraft.porkchop": "xuleta crúa",
  "item.minecraft.cooked_porkchop": "xuleta açá",
  "item.minecraft.painting": "cuadro",
  "item.minecraft.golden_apple": "pero d'oro",
  "item.minecraft.enchanted_golden_apple": "pero d'oro encantao",
  "block.minecraft.oak_sign": "letrero de quehigo",
  "block.minecraft.spruce_sign": "letrero de pinçapo",
  "block.minecraft.birch_sign": "letrero de xopo",
  "block.minecraft.jungle_sign": "letrero de hungla",
  "block.minecraft.acacia_sign": "letrero de mimoça",
  "block.minecraft.dark_oak_sign": "letrero de xaparro",
  "block.minecraft.crimson_sign": "letrero carmeçí",
  "block.minecraft.warped_sign": "letrero êttrambótico",
  "item.minecraft.bucket": "barde",
  "item.minecraft.water_bucket": "barde d'agua",
  "item.minecraft.lava_bucket": "barde de laba",
  "item.minecraft.minecart": "bagoneta",
  "item.minecraft.saddle": "siya de montâh",
  "item.minecraft.redstone": "porbo de redstone",
  "item.minecraft.snowball": "bola de niebe",
  "item.minecraft.oak_boat": "barca de quehigo",
  "item.minecraft.leather": "cuero",
  "item.minecraft.milk_bucket": "barde de lexe",
  "item.minecraft.pufferfish_bucket": "barde con pêh globo",
  "item.minecraft.salmon_bucket": "barde con çarmón",
  "item.minecraft.cod_bucket": "barde con abadeho",
  "item.minecraft.tropical_fish_bucket": "barde con pêh tropicâh",
  "item.minecraft.brick": "ladriyo",
  "item.minecraft.clay_ball": "bola d'arçiya",
  "block.minecraft.dried_kelp_block": "bloque d'argâ çecâ",
  "item.minecraft.paper": "papêh",
  "item.minecraft.book": "libro",
  "item.minecraft.slime_ball": "bola de limo",
  "item.minecraft.chest_minecart": "bagoneta con baûh",
  "item.minecraft.furnace_minecart": "bagoneta con hônno",
  "item.minecraft.egg": "guebo",
  "item.minecraft.compass": "brúhula",
  "item.minecraft.fishing_rod": "caña de pêccâh",
  "item.minecraft.clock": "relôh",
  "item.minecraft.glowstone_dust": "porbo de roca briyante",
  "item.minecraft.cod": "abadeho crúo",
  "item.minecraft.salmon": "çarmón crúo",
  "item.minecraft.tropical_fish": "pêh tropicâh",
  "item.minecraft.pufferfish": "pêh globo",
  "item.minecraft.cooked_cod": "abadeho açao",
  "item.minecraft.cooked_salmon": "çarmón açao",
  "item.minecraft.ink_sac": "çaco de tinta",
  "item.minecraft.red_dye": "tinte colorao",
  "item.minecraft.green_dye": "tinte berde",
  "item.minecraft.cocoa_beans": "çemiyâ de cacao",
  "item.minecraft.lapis_lazuli": "lapîl-láçuli",
  "item.minecraft.purple_dye": "tinte morao",
  "item.minecraft.cyan_dye": "tinte çian",
  "item.minecraft.light_gray_dye": "tinte grîh claro",
  "item.minecraft.gray_dye": "tinte grîh",
  "item.minecraft.pink_dye": "tinte roça",
  "item.minecraft.lime_dye": "tinte lima",
  "item.minecraft.yellow_dye": "tinte amariyo",
  "item.minecraft.light_blue_dye": "tinte açûh claro",
  "item.minecraft.magenta_dye": "tinte mahenta",
  "item.minecraft.orange_dye": "tinte naranha",
  "item.minecraft.bone_meal": "harina de gueço",
  "item.minecraft.blue_dye": "tinte açûh",
  "item.minecraft.brown_dye": "tinte marrón",
  "item.minecraft.black_dye": "tinte êccuro",
  "item.minecraft.white_dye": "tinte blanco",
  "item.minecraft.bone": "gueço",
  "item.minecraft.sugar": "açúcâ",
  "block.minecraft.cake": "pâttêh",
  "block.minecraft.white_bed": "cama blanca",
  "block.minecraft.orange_bed": "cama naranha",
  "block.minecraft.magenta_bed": "cama mahenta",
  "block.minecraft.light_blue_bed": "cama açûh claro",
  "block.minecraft.yellow_bed": "cama amariya",
  "block.minecraft.lime_bed": "cama lima",
  "block.minecraft.pink_bed": "cama roça",
  "block.minecraft.gray_bed": "cama grîh",
  "block.minecraft.light_gray_bed": "cama grîh claro",
  "block.minecraft.cyan_bed": "cama çian",
  "block.minecraft.purple_bed": "cama morá",
  "block.minecraft.blue_bed": "cama açûh",
  "block.minecraft.brown_bed": "cama marrón",
  "block.minecraft.green_bed": "cama berde",
  "block.minecraft.red_bed": "cama colorá",
  "block.minecraft.black_bed": "cama êccura",
  "item.minecraft.cookie": "gayeta",
  "item.minecraft.filled_map": "mapa□#0",
  "item.minecraft.shears": "êttiherâ",
  "item.minecraft.melon_slice": "tahá d'açendía",
  "item.minecraft.dried_kelp": "argâ çecâ",
  "item.minecraft.pumpkin_seeds": "çemiyâ de calabaça",
  "item.minecraft.melon_seeds": "çemiyâ d'açendía",
  "item.minecraft.beef": "bîtté crúo",
  "item.minecraft.cooked_beef": "bîtté açao",
  "item.minecraft.chicken": "poyo crúo",
  "item.minecraft.cooked_chicken": "poyo açao",
  "item.minecraft.rotten_flesh": "cânne podría",
  "item.minecraft.ender_pearl": "pêl-la d'ender",
  "item.minecraft.blaze_rod": "bara de blaze",
  "item.minecraft.ghast_tear": "lágrima de ghast",
  "item.minecraft.gold_nugget": "pepita d'oro",
  "item.minecraft.nether_wart": "berruga der nether",
  "item.minecraft.potion": "brebahe no crâtteablê□çin efêttô",
  "item.minecraft.glass_bottle": "frâcco de crîttâh",
  "item.minecraft.spider_eye": "oho d'araña",
  "item.minecraft.fermented_spider_eye": "oho d'araña fermentao",
  "item.minecraft.blaze_powder": "porbo de blaze",
  "item.minecraft.magma_cream": "crema de mâmma",
  "block.minecraft.brewing_stand": "alambique",
  "block.minecraft.cauldron": "cardero",
  "item.minecraft.ender_eye": "oho d'ender",
  "item.minecraft.glistering_melon_slice": "tahá d'açendía briyante",
  "item.minecraft.bat_spawn_egg": "guebo heneradôh de murçiégalo",
  "item.minecraft.bee_spawn_egg": "guebo heneradôh d'abeha",
  "item.minecraft.blaze_spawn_egg": "guebo heneradôh de blaze",
  "item.minecraft.cat_spawn_egg": "guebo heneradôh de gato",
  "item.minecraft.cave_spider_spawn_egg": "guebo heneradôh d'araña de cueba",
  "item.minecraft.chicken_spawn_egg": "guebo heneradôh de gayina",
  "item.minecraft.cod_spawn_egg": "guebo heneradôh d'abadeho",
  "item.minecraft.cow_spawn_egg": "guebo heneradôh de baca",
  "item.minecraft.creeper_spawn_egg": "guebo heneradôh de creeper",
  "item.minecraft.dolphin_spawn_egg": "guebo heneradôh de derfín",
  "item.minecraft.donkey_spawn_egg": "guebo heneradôh de burro",
  "item.minecraft.drowned_spawn_egg": "guebo heneradôh d'ahogao",
  "item.minecraft.elder_guardian_spawn_egg": "guebo heneradôh de guardián ançiano",
  "item.minecraft.enderman_spawn_egg": "guebo heneradôh d'enderman",
  "item.minecraft.endermite_spawn_egg": "guebo heneradôh d'endermite",
  "item.minecraft.evoker_spawn_egg": "guebo heneradôh d'imbocadôh",
  "item.minecraft.fox_spawn_egg": "guebo heneradôh de çorro",
  "item.minecraft.ghast_spawn_egg": "guebo heneradôh de ghast",
  "item.minecraft.guardian_spawn_egg": "guebo heneradôh de guardián",
  "item.minecraft.hoglin_spawn_egg": "guebo heneradôh de hoglin",
  "item.minecraft.horse_spawn_egg": "guebo heneradôh de haca",
  "item.minecraft.husk_spawn_egg": "guebo heneradôh de momia",
  "item.minecraft.llama_spawn_egg": "guebo heneradôh de yama",
  "item.minecraft.magma_cube_spawn_egg": "guebo heneradôh de cubo de mâmma",
  "item.minecraft.mooshroom_spawn_egg": "guebo heneradôh de bacaçeta",
  "item.minecraft.mule_spawn_egg": "guebo heneradôh de mula",
  "item.minecraft.ocelot_spawn_egg": "guebo heneradôh d'oçelote",
  "item.minecraft.panda_spawn_egg": "guebo heneradôh de panda",
  "item.minecraft.parrot_spawn_egg": "guebo heneradôh de loro",
  "item.minecraft.phantom_spawn_egg": "guebo heneradôh de fantâmma",
  "item.minecraft.pig_spawn_egg": "guebo heneradôh de coxino",
  "item.minecraft.piglin_spawn_egg": "guebo heneradôh de piglin",
  "item.minecraft.pillager_spawn_egg": "guebo heneradôh de çaqueadôh",
  "item.minecraft.polar_bear_spawn_egg": "guebo heneradôh d'oço polâh",
  "item.minecraft.pufferfish_spawn_egg": "guebo heneradôh de peh globo",
  "item.minecraft.rabbit_spawn_egg": "guebo heneradôh de coneho",
  "item.minecraft.ravager_spawn_egg": "guebo heneradôh de debâttadôh",
  "item.minecraft.salmon_spawn_egg": "guebo heneradôh de çarmón",
  "item.minecraft.sheep_spawn_egg": "guebo heneradôh d'obeha",
  "item.minecraft.shulker_spawn_egg": "guebo heneradôh de shulker",
  "item.minecraft.silverfish_spawn_egg": "guebo heneradôh de lepîmma",
  "item.minecraft.skeleton_spawn_egg": "guebo heneradôh de canina",
  "item.minecraft.skeleton_horse_spawn_egg": "guebo heneradôh de haca canina",
  "item.minecraft.slime_spawn_egg": "guebo heneradôh de limo",
  "item.minecraft.spider_spawn_egg": "guebo heneradôh d'araña",
  "item.minecraft.squid_spawn_egg": "guebo heneradôh de xoco",
  "item.minecraft.stray_spawn_egg": "guebo heneradôh d'errante",
  "item.minecraft.strider_spawn_egg": "guebo heneradôh de strider",
  "item.minecraft.trader_llama_spawn_egg": "guebo heneradôh de yama ambulante",
  "item.minecraft.tropical_fish_spawn_egg": "guebo heneradôh de pêh tropicâh",
  "item.minecraft.turtle_spawn_egg": "guebo heneradôh de tortuga",
  "item.minecraft.vex_spawn_egg": "guebo heneradôh d'êppíritu",
  "item.minecraft.villager_spawn_egg": "guebo heneradôh d'ardeano",
  "item.minecraft.vindicator_spawn_egg": "guebo heneradôh de bindicadôh",
  "item.minecraft.wandering_trader_spawn_egg": "guebo heneradôh de bendedôh ambulante",
  "item.minecraft.witch_spawn_egg": "guebo heneradôh de bruha",
  "item.minecraft.wither_skeleton_spawn_egg": "guebo heneradôh de canina der wither",
  "item.minecraft.wolf_spawn_egg": "guebo heneradôh de lobo",
  "item.minecraft.zoglin_spawn_egg": "guebo heneradôh de zoglin",
  "item.minecraft.zombie_spawn_egg": "guebo heneradôh de çombi",
  "item.minecraft.zombie_horse_spawn_egg": "guebo heneradôh de haca çombi",
  "item.minecraft.zombie_villager_spawn_egg": "guebo heneradôh d'ardeano çombi",
  "item.minecraft.zombified_piglin_spawn_egg": "guebo heneradôh de piglin çombificao",
  "item.minecraft.experience_bottle": "frâcco con êpperiençia",
  "item.minecraft.fire_charge": "carga ínnea",
  "item.minecraft.writable_book": "libro y pluma",
  "item.minecraft.written_book": "libro êccrito",
  "item.minecraft.emerald": "êmmerarda",
  "item.minecraft.item_frame": "marco",
  "block.minecraft.flower_pot": "tiêtto",
  "item.minecraft.carrot": "çanahoria",
  "item.minecraft.potato": "papa",
  "item.minecraft.baked_potato": "papa açá",
  "item.minecraft.poisonous_potato": "papa benenoça",
  "item.minecraft.map": "mapa en blanco",
  "item.minecraft.golden_carrot": "çanahoria dorá",
  "block.minecraft.skeleton_skull": "calabera de canina",
  "block.minecraft.wither_skeleton_skull": "calabera de canina der wither",
  "block.minecraft.player_head": "cabeça de hugadôh",
  "block.minecraft.zombie_head": "cabeça de çombi",
  "block.minecraft.creeper_head": "cabeça de creeper",
  "block.minecraft.dragon_head": "cabeça de dragón",
  "item.minecraft.carrot_on_a_stick": "çanahoria n'una caña",
  "item.minecraft.warped_fungus_on_a_stick": "hongo êttrambótico n'una caña",
  "item.minecraft.nether_star": "êttreya der nether",
  "item.minecraft.pumpkin_pie": "tarta de calabaça",
  "item.minecraft.firework_rocket": "fuegô artifiçialê",
  "item.minecraft.firework_star": "êttreya de fuegô artifiçialê",
  "item.minecraft.enchanted_book": "libro encantao",
  "item.minecraft.nether_brick": "ladriyô der nether",
  "item.minecraft.quartz": "cuarço der nether",
  "item.minecraft.tnt_minecart": "bagoneta con tnt",
  "item.minecraft.hopper_minecart": "bagoneta con torba",
  "item.minecraft.prismarine_shard": "frâmmento de prîmmarina",
  "item.minecraft.prismarine_crystals": "crîttalê de prîmmarina",
  "item.minecraft.rabbit": "coneho crúo",
  "item.minecraft.cooked_rabbit": "coneho açao",
  "item.minecraft.rabbit_stew": "puxero con coneho",
  "item.minecraft.rabbit_foot": "pata de coneho",
  "item.minecraft.rabbit_hide": "peyeho de coneho",
  "item.minecraft.armor_stand": "maniquí",
  "item.minecraft.iron_horse_armor": "armaúra de yerro pa haca",
  "item.minecraft.golden_horse_armor": "armaúra d'oro pa haca",
  "item.minecraft.diamond_horse_armor": "armaúra de diamante pa haca",
  "item.minecraft.leather_horse_armor": "armaúra de cuero pa haca",
  "item.minecraft.lead": "rienda",
  "item.minecraft.name_tag": "etiqueta",
  "item.minecraft.command_block_minecart": "bagoneta con bloque de comandô",
  "item.minecraft.mutton": "cordero crúo",
  "item.minecraft.cooked_mutton": "cordero açao",
  "block.minecraft.white_banner": "êttandarte blanco",
  "block.minecraft.orange_banner": "êttandarte naranha",
  "block.minecraft.magenta_banner": "êttandarte mahenta",
  "block.minecraft.light_blue_banner": "êttandarte açûh claro",
  "block.minecraft.yellow_banner": "êttandarte amariyo",
  "block.minecraft.lime_banner": "êttandarte lima",
  "block.minecraft.pink_banner": "êttandarte roça",
  "block.minecraft.gray_banner": "êttandarte grîh",
  "block.minecraft.light_gray_banner": "êttandarte grîh claro",
  "block.minecraft.cyan_banner": "êttandarte çian",
  "block.minecraft.purple_banner": "êttandarte morao",
  "block.minecraft.blue_banner": "êttandarte açûh",
  "block.minecraft.brown_banner": "êttandarte marrón",
  "block.minecraft.green_banner": "êttandarte berde",
  "block.minecraft.red_banner": "êttandarte colorao",
  "block.minecraft.black_banner": "êttandarte êccuro",
  "item.minecraft.end_crystal": "crîttâh del end",
  "item.minecraft.chorus_fruit": "fruta de chorus",
  "item.minecraft.popped_chorus_fruit": "fruta de corus açá",
  "item.minecraft.beetroot": "remolaxa",
  "item.minecraft.beetroot_seeds": "çemiyâ de remolaxa",
  "item.minecraft.beetroot_soup": "çopa de remolaxa",
  "item.minecraft.dragon_breath": "aliento de dragón",
  "item.minecraft.splash_potion": "brebahe lançable no crâtteablê□çin efêttô",
  "item.minecraft.spectral_arrow": "flexa êppêttrâh",
  "item.minecraft.tipped_arrow": "flexa con efêtto no crâtteablê□çin efêttô",
  "item.minecraft.lingering_potion": "brebahe perçîttente no crâtteablê□çin efêttô",
  "item.minecraft.shield": "êccúo",
  "item.minecraft.elytra": "elytra",
  "item.minecraft.spruce_boat": "barca de pinçapo",
  "item.minecraft.birch_boat": "barca de xopo",
  "item.minecraft.jungle_boat": "barca de hungla",
  "item.minecraft.acacia_boat": "barca de mimoça",
  "item.minecraft.dark_oak_boat": "barca de xaparro",
  "item.minecraft.totem_of_undying": "tótem d'îmmortalidá",
  "item.minecraft.shulker_shell": "caparaçón de shulker",
  "item.minecraft.iron_nugget": "pepita de yerro",
  "item.minecraft.knowledge_book": "ençiclopedia",
  "item.minecraft.debug_stick": "tarama / palo de depuraçión",
  "item.minecraft.music_disc_13": "dîcco de múçica□c418 - 13",
  "item.minecraft.music_disc_cat": "dîcco de múçica□c418 - cat",
  "item.minecraft.music_disc_blocks": "dîcco de múçica□c418 - blocks",
  "item.minecraft.music_disc_chirp": "dîcco de múçica□c418 - chirp",
  "item.minecraft.music_disc_far": "dîcco de múçica□c418 - far",
  "item.minecraft.music_disc_mall": "dîcco de múçica□c418 - mall",
  "item.minecraft.music_disc_mellohi": "dîcco de múçica□c418 - mellohi",
  "item.minecraft.music_disc_stal": "dîcco de múçica□c418 - stal",
  "item.minecraft.music_disc_strad": "dîcco de múçica□c418 - strad",
  "item.minecraft.music_disc_ward": "dîcco de múçica□c418 - ward",
  "item.minecraft.music_disc_11": "dîcco de múçica□c418 - 11",
  "item.minecraft.music_disc_wait": "dîcco de múçica□c418 - wait",
  "item.minecraft.music_disc_pigstep": "dîcco de múçica□lena raine - pigstep",
  "item.minecraft.trident": "tridente□□en la mano prinçipâh:□+8 daño d'ataque□-2.9 beloçidá d'ataque",
  "item.minecraft.phantom_membrane": "membrana de fantâmma",
  "item.minecraft.nautilus_shell": "caparaçón de nautilo",
  "item.minecraft.heart_of_the_sea": "coraçón der mâh",
  "item.minecraft.crossbow": "bayêtta",
  "item.minecraft.suspicious_stew": "potahe çôppexoço",
  "block.minecraft.loom": "telâh",
  "item.minecraft.flower_banner_pattern": "diçeño d'êttandarte□êttampao de flôh",
  "item.minecraft.creeper_banner_pattern": "diçeño d'êttandarte□êttampao de creeper",
  "item.minecraft.skull_banner_pattern": "diçeño d'êttandarte□êttampao de calabera",
  "item.minecraft.mojang_banner_pattern": "diçeño d'êttandarte□êttampao de mojang",
  "item.minecraft.globe_banner_pattern": "diçeño d'êttandarte□êttampao de planeta",
  "item.minecraft.piglin_banner_pattern": "diçeño d'êttandarte□êttampao de hoçico",
  "block.minecraft.composter": "compôttadôh",
  "block.minecraft.barrel": "barrîh",
  "block.minecraft.smoker": "ahumadôh",
  "block.minecraft.blast_furnace": "forha",
  "block.minecraft.cartography_table": "meça de cartografía",
  "block.minecraft.fletching_table": "meça de flexâ",
  "block.minecraft.grindstone": "muela d'afilâh",
  "block.minecraft.lectern": "atrîh",
  "block.minecraft.smithing_table": "meça de herrería",
  "block.minecraft.stonecutter": "cortapiedrâ",
  "block.minecraft.bell": "campana",
  "block.minecraft.lantern": "faroliyo",
  "block.minecraft.soul_lantern": "faroliyo d'ánimâ",
  "item.minecraft.sweet_berries": "bayâ durçê",
  "block.minecraft.campfire": "candela",
  "block.minecraft.soul_campfire": "candela d'ánimâ",
  "block.minecraft.shroomlight": "briyongo",
  "item.minecraft.honeycomb": "panâh",
  "block.minecraft.bee_nest": "cormena",
  "block.minecraft.beehive": "apiario",
  "item.minecraft.honey_bottle": "frâcco con miêh",
  "block.minecraft.honey_block": "bloque de miêh",
  "block.minecraft.honeycomb_block": "bloque de panâh",
  "block.minecraft.lodestone": "mânnetita",
  "block.minecraft.netherite_block": "bloque de netherita",
  "block.minecraft.ancient_debris": "detritô ançêttralê",
  "block.minecraft.target": "diana",
  "block.minecraft.crying_obsidian": "ôççidiana lacrimoça",
  "block.minecraft.blackstone": "açabaxe",
  "block.minecraft.blackstone_slab": "bardoça d'açabaxe",
  "block.minecraft.blackstone_stairs": "êccalerâ d'açabaxe",
  "block.minecraft.gilded_blackstone": "açabaxe áureo",
  "block.minecraft.polished_blackstone": "açabaxe pulío",
  "block.minecraft.polished_blackstone_slab": "bardoça d'açabaxe pulío",
  "block.minecraft.polished_blackstone_stairs": "êccalerâ d'açabaxe pulío",
  "block.minecraft.chiseled_polished_blackstone": "açabaxe pulío êccurpío",
  "block.minecraft.polished_blackstone_bricks": "ladriyô d'açabaxe pulío",
  "block.minecraft.polished_blackstone_brick_slab": "bardoça de ladriyô d'açabaxe pulío",
  "block.minecraft.polished_blackstone_brick_stairs": "êccalerâ de ladriyô d'açabaxe pulío",
  "block.minecraft.cracked_polished_blackstone_bricks": "ladriyô d'açabaxe pulío rêqquebrahao",
  "block.minecraft.respawn_anchor": "áncora de reapariçión",
}
export const esan = items; 
